<template>
  <v-tooltip bottom max-width="340">
    <template v-slot:activator="{ on }">
      <span v-on="on" class="header-hint">
        {{ text }}<v-icon x-small class="ml-1">info_outline</v-icon>
      </span>
    </template>
    <span>{{ hint }}</span>
  </v-tooltip>
</template>

<script>
  export default {
    name: 'HeaderHint',
    props: {
      text: {
        type: String,
        default: '',
      },
      hint: {
        type: String,
        default: '',
      },
    },
  };
</script>

<style scoped>
  .header-hint {
    cursor: help;
    white-space: nowrap;
  }
</style>
